import React, { useEffect } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusSection } from './components/BonusSection';
import { Benefits } from './components/Benefits';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchasePopup } from './components/PurchasePopup';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
const PIXEL_ID = '1037491992204255';
export function App() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    try {
      if (!pixelWindow.fbq) {
        const fbq = ((...args: unknown[]) => {
          if (fbq.callMethod) {
            fbq.callMethod(...args);
          } else {
            fbq.queue?.push(args);
          }
        }) as PixelFunction;
        pixelWindow.fbq = fbq;
        if (!pixelWindow._fbq) pixelWindow._fbq = fbq;
        fbq.push = fbq;
        fbq.loaded = true;
        fbq.version = '2.0';
        fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        const firstScript = document.getElementsByTagName('script')[0];
        if (firstScript?.parentNode) {
          firstScript.parentNode.insertBefore(script, firstScript);
        } else {
          document.head.appendChild(script);
        }
      }
      pixelWindow.fbq?.('init', PIXEL_ID);
      pixelWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel init skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3uf5hdlp0gd89">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-1" data-mp="d4e75xjpjkyt" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-ink-bg text-ink-text" data-id="element-2" data-mp="83i6rtykegy5">
        <UrgencyBanner data-id="element-3" data-mp="3glnz048296jt" />
        <main data-id="element-4" data-mp="3bmbevr8kqdkx">
          <Hero data-id="element-5" data-mp="3bmtixa1h9w3e" />
          <PainSection data-id="element-6" data-mp="3bn30qacdcwy0" />
          <SystemSection data-id="element-7" data-mp="3bnuwpm9vowot" />
          <BonusSection data-id="element-8" data-mp="3bkgq21u6m1bk" />
          <Benefits data-id="element-9" data-mp="3qbpo8zc5gv0b" />
          <Offer data-id="element-10" data-mp="3qc966g1svjec" />
          <Guarantee data-id="element-11" data-mp="3qcr0h74wjnjm" />
          <Testimonials data-id="element-12" data-mp="3qdajkr6aghz8" />
          <FAQ data-id="element-13" data-mp="3lkr4fprydesb" />
          <FinalCTA data-id="element-14" data-mp="3lk7m47ye4odr" />
        </main>
        <Footer data-id="element-15" data-mp="3liwgs3par8kj" />
        <PurchasePopup data-id="element-16" data-mp="3liehey7c8e8e" />
      </div>
    </>;
}